import createReactComponent from '../createReactComponent';
export default createReactComponent('outline', 'arrow-up-left', 'IconArrowUpLeft', [["path",{"d":"M7 7l10 10","key":"svg-0"}],["path",{"d":"M16 7l-9 0l0 9","key":"svg-1"}]]);